<div class="tablePreview">
  <table class="table">
    <caption></caption>
    <thead>
      @if (showTableHeader) {
        <tr class="header row">
          <td [attr.colspan]="visibleColumnCount">{{tableHeaderName}}</td>
        </tr>
      }
      @if (showColumnTitle) {
        <tr class="columnTitle row">
          @for (col of colDef; track col) {
            @if (col.visible) {
              <th id="colColumnTextColor" [style.background-color]="'#'+ col.columnBgColor"
                [style.color]="col.columnTextColor" #columnHeader insTooltip
                [cfg]="getToolTipConf(columnHeader, col.columnName)">
                {{col.columnName}}
              </th>
            }
          }
        </tr>
      }
    </thead>
    <perfect-scrollbar class="scrollbar" [style.height.px]="tableHeight">
      <tbody>
        @for (item of rowData; track item) {
          <tr class="row">
            @for (col of colDef; track col) {
              @if (col.visible) {
                <td [style.background-color]="'#'+ col.columnBgColor"
                  [style.color]="col.columnTextColor" #columnCell insTooltip
                  [cfg]="getToolTipConf(columnCell, item[col.field])">
                  {{item[col.field]}}
                </td>
              }
            }
          </tr>
        }
      </tbody>
    </perfect-scrollbar>
  </table>
</div>